import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import BaseForm from '../../../template/BaseForm';
import { TextArea } from 'devextreme-react';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../../services/AplicationService';
import { showSuccessMessage, showConfirmationMessage, handleError } from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import '../../../utils/Messages';

const masterProps = {
	title: 'Cadastro de Navios',
	subtitle: 'Gerencie o cadastro de navios',
};
const initialState = {
	ship: { id: null, name: '', description: '', enabled: true },
	term: '',
};
export default class Ship extends Component {
	state = { ...initialState };
	ship = { id: null, name: '', description: '', enabled: true };
	constructor(props) {
		super(props);
		this.loadListShips = this.loadListShips.bind(this);
		this.getShip = this.getShip.bind(this);
		this.deleteShip = this.deleteShip.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.saveShip = this.saveShip.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getShip(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('ships/' + key)
			.then(response => {
				this.ship = { ...response.data };
				this.setState({ ...this.state, ship: this.ship });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteShip(key) {
		API.delete('ships/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	saveShip() {
		this.crudForm.current.showLoadingPanel(true);
		let ship = { ...this.ship };
		if (ship.id === null) {
			API.post('ships/', ship)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					ship = response.data;
					this.ship = ship;
					this.setState({ ship: this.ship });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('ships/' + ship.id, ship)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.ship = ship;
					this.setState({ ship: this.ship });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListShips(page, pageSize) {
		let term = this.state.term;
		return API.get('/ships', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.ships,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteShip}
					fncGetData={this.getShip}
					fncListData={this.loadListShips}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{ dataField: 'name', caption: 'Nome', width: '60%' },
						{ dataField: 'description', caption: 'Descrição' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						},
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.ship = { ...initialState.ship };
		this.setState({ ...this.state, ship: this.ship });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onClickSave = function() {
		this.saveShip();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<Form formData={this.ship} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
				<GroupItem>
					<GroupItem colCount={7}>
						<SimpleItem
							dataField={'id'}
							cssClass="uppercase"
							label={{ text: 'Código' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem dataField={'enabled'} editorType={'dxCheckBox'} label={{ text: 'Ativo' }} />
					</GroupItem>
					<GroupItem>
						<SimpleItem dataField={'name'} cssClass="uppercase" label={{ text: 'Nome' }} />
						<SimpleItem
							dataField={'description'}
							editorType={'dxTextArea'}
							editorOptions={{ inputAttr: { rows: 10 } }}
							label={{ text: 'Observação' }}
						/>
					</GroupItem>
					<GroupItem>
						<div className="pull-right">
							<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
								<i className="fa fa-plus" />
								&nbsp; Novo
							</button>
							<button type="button" className="btn btn-success" onClick={this.onClickSave}>
								<i className="fa fa-check" />
								&nbsp; Salvar
							</button>
						</div>
					</GroupItem>
				</GroupItem>
			</Form>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();

		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
